import { Card } from "antd";
import { useEffect, useState } from "react";
import { EmptyView } from "../shared/EmptyView";

export default function SummaryCard(props) {
    const [isEmpty, setEmpty] = useState(false);

    useEffect(() => {
        if (!props.children) setEmpty(true);
        if (Array.isArray(props.children)) {
            if (props.children.length === 0) {
                setEmpty(true)
            } else {
                setEmpty(props.children.every(child => child.length === 0))
            }
        }
    }, [props.children])

    return (
        <Card
            title={props.title}
            extra={props.extra}
            className="overflow-hidden flex-1 pb-14"
            bodyStyle={{ height: "100%", overflowY: "auto" }}
            bordered={false}
        >
            {isEmpty ? <EmptyView name={props.title} /> : props.children}
        </Card>
    );
}
